import { Component } from '@angular/core';
import { LandingComponent } from '../landing/landing.component';
import { ErrorService } from '../error/error.service';
import { LandingService } from '../landing/landing.service';
import { TravelersService } from '../travelers/travelers.service';
import { TravellersService } from '../travelers/travellers.service';
import { AppService } from '../../app.service';
import { ONBOARD_CONSTANTS } from '../../app.constants';
import { environment } from '../../../environments/environment';
import { HttpService } from '../../services/http.service';
import {PnrFormDataModel} from '../travelers/travelers.model';
import { BuywifiService } from '../../services/buywifi.service';

@Component({
  selector: 'app-paymentSelection',
  templateUrl: './paymentSelection.component.html',
  styleUrls: ['./paymentSelection.component.css']
})
export class PaymentSelectionComponent {

  static showEBforPointsBuy = false;
  static buyMoreFlowForEB = true; 
  public isSiteLogin: boolean; 
  constructor(private errorService: ErrorService,
    private landingService: LandingService,
    private travelersService: TravelersService,
    private travellersService: TravellersService,
    private appService: AppService,
    private httpService: HttpService,
    private buywifiService: BuywifiService) {
  }
  
  closePaySelectionOverlay() {    
    LandingComponent.showPaymentSelectionScreen = false;
    PaymentSelectionComponent.showEBforPointsBuy = false;
  }

  redirectToPointsBuywifi() {
    this.appService.showLoader();
    const isCharter = this.appService.getFlightServiceType();
    LandingComponent.showPaymentSelectionScreen = false;  
    PaymentSelectionComponent.showEBforPointsBuy = true;
    this.isSiteLogin = sessionStorage.getItem('sessionId')?.length > 0 || false;
    const getDeviceData = this.landingService.getGetDeviceResponse();
    if((this.isSiteLogin || isCharter)  && getDeviceData['status'].code !== 'FULL') {
      for (const link of this.appService.getPassengerIdData()) {
        if (link.rel === 'paxAssociatedPnrDetails' || link.rel === 'PassengerAssociatedDevices') {
          const loaderTextList = { loaderHeaderText: 'loaderText' };
          //this.appService.showLoaderWithText(loaderTextList);
          this.errorService.removeError();
          const paxId = link.href.split('=')[1];
          const passengerRequest = this.getPassengerRequest(paxId);
          this.httpService.getData(passengerRequest).subscribe(
            passengerResponse => {
              //console.log('Passenger RES: ', passengerResponse)
              if (passengerResponse.errors) {
              //console.log('Passenger RES Errors: ', passengerResponse.errors)
              this.errorService.addError(passengerResponse.errors);
              this.appService.hideLoader();
              }
              else {                                
                const passengerDetail = new PnrFormDataModel();
                passengerDetail.firstname = passengerResponse.firstName;
                passengerDetail.secondname = passengerResponse.lastName;
                if(isCharter) {
                  passengerDetail.paxid = paxId;
                  this.travelersService.setPnrFormData(passengerDetail);
                  LandingComponent.showActivateScreen = true;
                  LandingComponent.showToggleButton = false;
                }
                else {
                  passengerDetail.pnr = passengerResponse.bookingReference;            
                  this.travelersService.setPnrFormData(passengerDetail);
                  this.travellersService.getPointsOffer();          
                }
              }
            },
            error => {
              return this.buywifiService.setDefaultError();
            });
        }
      }  
    }
    else if ((this.isSiteLogin || isCharter) && getDeviceData['status'].code === 'FULL') {
      LandingComponent.showPaymentSelectionScreen = false;
      const deviceToken = this.appService.getDeviceToken();
      const getDevicRequestEntity = this.landingService.getDeviceRequestEntity(deviceToken);
      this.httpService.getData(getDevicRequestEntity).subscribe(
        getDeviceResponse => {
          if (getDeviceResponse.errors) {
            this.errorService.addError(getDeviceResponse.errors);
            this.appService.hideLoader();
            return false;
          } else {
            if(getDeviceResponse!==null) {
              this.appService.setGetDeviceResponse(getDeviceResponse);
              if(isCharter) {
                const passengerDataForCharterForm = {            
                  'firstname': getDeviceResponse.passenger.firstName, 
                  'secondname': getDeviceResponse.passenger.lastName,
                  'email': getDeviceResponse.passenger.email
                }                
                this.travelersService.setCharterFormData(passengerDataForCharterForm);
                LandingComponent.showActivateScreen = true;
                LandingComponent.showToggleButton = false;
              }
              else {
                this.travellersService.getPointsOffer();
              }              
            }
          }
        },
        error => {
          return this.buywifiService.setDefaultError();
        }
      );      
    }
    else {
      LandingComponent.showPaymentSelectionScreen = false;
      LandingComponent.showActivateScreen = true;
      LandingComponent.showToggleButton = false;
    }        
  }
  getPassengerRequest(paxId: any) {
    const requestPassengerCall = {
      url: environment.apiBaseUrl + ONBOARD_CONSTANTS.GET_PASSENGER_PAXID.replace('<<passengerId>>', paxId)
    };
    return requestPassengerCall;
  }

  

  redirectToBuywifi() {
    if (PaymentSelectionComponent.buyMoreFlowForEB) {
      this.appService.showLoader();
      LandingComponent.showPaymentSelectionScreen = false;
      PaymentSelectionComponent.showEBforPointsBuy = false;             
      LandingComponent.showActivateScreen = true;
      LandingComponent.showToggleButton = false;
      this.errorService.removeError();
    }
    else {
      PaymentSelectionComponent.showEBforPointsBuy = false;
      LandingComponent.showPaymentSelectionScreen = false;
      const loaderTextList = { loaderHeaderText: 'loaderText' };
      const pnrFormData = this.travelersService.getPnrFormData();
      const isCharter = this.appService.getFlightServiceType();
      this.travellersService.setPassengerDetails(pnrFormData);
      this.appService.showLoaderWithText(loaderTextList);
      if (isCharter) {
        this.travellersService.buildCharterAncillaryOffers();
      } else {
        this.travellersService.buildAncillaryOffers();
      }
    }
  }
}
